import { CustomerChatGateway } from './customer-chat-gateway.interface';

const baseUrl = 'customer/chats';
export class HttpCustomerChatGateway implements CustomerChatGateway {

  getChatByProject(args: { projectId: string }) {
    return { url: `${baseUrl}/${args.projectId}`, method: 'GET' };
  }

  postMessage(args: { projectId: string; data: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/post-message`,
      method: 'POST',
      data: args.data,
    };
  }

  deleteMessage(args: { chatMessageId: string }) {
    return {
      url: `${baseUrl}/${args.chatMessageId}/messages`,
      method: 'DELETE',
    };
  }

  getDocument(args: { chatMessageId: string }) {
    return {
      url: `${baseUrl}/${args.chatMessageId}/get-document`,
      method: 'GET',
    };
  }
}
